import { CaseVoucherTags } from '../index.js';
import { VoucherCategory, VoucherTypeIds, VoucherTypeSetting } from './index.js';
export const CollectionComissionVoucherTypes = [
    VoucherTypeIds.COLLECTIONCOMMISSION,
    VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT,
    VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE,
];
export const RegularFeeVoucherTypes = [
    VoucherTypeIds.ENDCASEFEE,
    VoucherTypeIds.RKIREGISTRATIONFEE,
    VoucherTypeIds.BPKFEE,
    VoucherTypeIds.FOLKEREGISTEROPSLAG,
    VoucherTypeIds.ANMELDELSEAFKRAV,
    VoucherTypeIds.FOGEDFEE,
    VoucherTypeIds.JURIDISKBISTAND,
    VoucherTypeIds.STARTCASEFEE,
    VoucherTypeIds.BERAMMELSESAFGIFT,
    VoucherTypeIds.AFLYSNINGAFUDLAEG,
    VoucherTypeIds.LOCKSMITHFEE,
    VoucherTypeIds.DRIVINGFEE,
    VoucherTypeIds.OTHERFEE,
];
export const FeeVoucherTypes = [
    ...CollectionComissionVoucherTypes,
    ...RegularFeeVoucherTypes,
];
export const DisbursementVoucherTypes = [
    VoucherTypeIds.BPKDISBURSEMENT,
    VoucherTypeIds.FOGEDDISBURSEMENT,
    VoucherTypeIds.POLICEDISBURSEMENT,
    VoucherTypeIds.STAEVNINGSGEBYR,
    VoucherTypeIds.BERAMMELSESAFGIFT,
];
export const CaseVoucherCategories = [
    VoucherCategory.TRANSACTION,
    VoucherCategory.PRINCIPAL,
    VoucherCategory.COST,
    VoucherCategory.COURTCOST,
    VoucherCategory.INTEREST,
];
export const OrderedCaseVoucherCategories = [
    VoucherCategory.PRINCIPAL,
    VoucherCategory.COST,
    VoucherCategory.COURTCOST,
    VoucherCategory.INTEREST,
    VoucherCategory.TRANSACTION,
];
export const DebtorImposedBy = [
    CaseVoucherTags.IMPOSEDBYCREDITOR,
    CaseVoucherTags.IMPOSEDBYCOLLECTOR,
];
export const CaseVoucherInterestSettings = [
    VoucherTypeSetting.CompoundInterest,
    VoucherTypeSetting.InterestFromTable,
    VoucherTypeSetting.YearlyInterest,
];
//# sourceMappingURL=setup.js.map